import SelectOtherAssetForm from "./SelectOtherAssetForm";

export default SelectOtherAssetForm;
